import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import useSWRMutation from "swr/mutation";
import { mutate } from "swr";

import {
  getSettingState,
  setAlertDialog,
  setAlertDialogData,
} from "../../redux/features/settingSlice";
import { fetcherPost } from "../../services/fetcher";

const useFollow = (rowData, followBtn, setFollowBtn) => {
  const { userData } = useSelector(getSettingState);
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  let urlParams = location.pathname.split("/");

  const { trigger } = useSWRMutation(
    [
      `${process.env.REACT_APP_API}/auth/profile/${followBtn ? "unfollow" : "follow"}/`,
      tokenStorage,
    ],
    fetcherPost,
    {
      onSuccess: () => {
        setFollowBtn && setFollowBtn((e) => !e);

        if (urlParams[1] === "profile" && !urlParams[2]) {
          mutate([`${process.env.REACT_APP_API}/auth/profile/${userData}/`, tokenStorage]);
        }
        if (urlParams[1] === "profile" && urlParams[2]) {
          mutate([
            `${process.env.REACT_APP_API}/auth/v2/profile/${urlParams[2]}/`,
            tokenStorage,
          ]);
        }
      },
      onError: (e) => {
        if (e.request.statusText === "Unauthorized") {
        }
      },
    }
  );

  const handleFollowBtn = async () => {
    if (userData) {
      try {
        await trigger({ user_id: rowData?.id });
      } catch {}
    } else {
      dispatch(setAlertDialog(true));
      dispatch(
        setAlertDialogData({
          title: "You are not logged in!",
          dis: "You should log into your account to follow.",
          btn1: "Cancel",
          btn2: "Login",
          btn2Onclick: () => navigate("/login"),
        })
      );
    }
  };
  return [handleFollowBtn];
};
export default useFollow;
